"use client";

import { useForm } from "react-hook-form";
import { usePathname } from "next/navigation";
//
import {
    FormProvider,
    handleFormSubmit,
    RenderDynamicForm,
    generateFormSchema,
} from "@/components";
import { getImageURL } from "@/lib";
import { useState, useRef, useEffect } from "react";

export const PartnerPageForm = ({ data = {} }) => {
    const { form, title, subtitle, image } = data;

    const pathname = usePathname()?.split("/");
    const methods = useForm(generateFormSchema(form));
    
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const successRef = useRef(null);
    
    useEffect(() => {
        if (isSubmitted && successRef.current) {
            successRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [isSubmitted]);

    const onSubmit = methods["handleSubmit"](async (data) => {
        let payload = {
            form_id: form?.id,
            page_id: pathname?.[pathname?.length - 1],
            fields: data,
        };

        const {
            status,
            message,
            data: returnedData,
            errors,
        } = await handleFormSubmit({ data: payload, methods: methods });

        if (status) {
            methods["clearErrors"]();
            methods["reset"]();
            setIsSubmitted(true);
            setSuccessMessage(message || "Form submitted successfully!");
        }
    });

    return (
        <section
            className="cta__section faq__form_section"
            style={{
                backgroundImage: `url(${getImageURL(image?.src)})`,
                backgroundSize: "cover",
                backgroundPosition: "50% 50%",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="section_overlay" />
            <div className="custom-container">
                <div className="row">
                    <div className="col-12 ">
                        <div className="section_header text-center">
                            <h4
                                className="heading fs-48 fw-300"
                                dangerouslySetInnerHTML={{
                                    __html: title,
                                }}
                            />
                        </div>
                        {!isSubmitted ? (
                            <FormProvider
                                methods={methods}
                                onSubmit={onSubmit}
                                className="cta__form faq__form"
                            >
                                <RenderDynamicForm formData={form} />
                            </FormProvider>
                        ) : (
                            <div ref={successRef} className="success-message">
                                <div className="d-flex">
                                    <div
                                        className="icon_wrap text-primary"
                                        style={{ marginTop: "5px", marginRight: "10px" }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="48" height="48" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
                                        </svg>
                                    </div>
                                    <div className="alert alert-success" role="alert">
                                        <h5 className="alert-heading fs-48 text-primary">Success!</h5>
                                        <p className="mb-0 fs-36">{successMessage}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};